module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"terminate":"Close"},"fr":{"terminate":"Terminer"},"de":{"terminate":"Beenden"}}')
  delete Component.options._Ctor
}
